import { InputValue } from ".";

export interface ProcessConfig {
  id: number;
  name: string;
  isDefault: boolean;
  modifiedOn: string;
  modifiedBy: string;
  arrivedStepId: number;
  endConferenceStepId: number;
  finishedStepIds: number[];

  processStates: ProcessState[];
  processSteps: ProcessStep[];
  surveyorList: string[];
}

export interface ProcessState {
  id: number;
  name: string;
  order: number;
  scope: string[];
  requiredSteps: RequiredStepModel[];
}

export interface ProcessStep {
  id: number;
  name: string;
  stateId: number | undefined;
  activityType: number;
  processType: number;
  groupIndex: number;
  delayReasons: DelayReasonModel;
  inputValues: InputValue[] | undefined;
  nextSteps: NextStepsModel[];
  processActions: ProcessAction[];
}

export interface NextStepsModel {
  stepIds: number[];
  conditions: Conditions;
}

export interface ProcessAction {
  id: number;
  processStepId: number;
  name: string;
  caption: string;
  icon: string;
  type: string;
  displayCondition: number;
  delayReasons: DelayReasonModel;
  inputValues: InputValue[] | undefined;
  actionDetails: ActionDetails | undefined;
}

export interface ActionDetails {
  nextSteps: NextStepModel[] | undefined;
  triggerActions: TriggerActionModel[] | undefined;

  modifyData: ModifyDataModel;
  conditionExp: ConditionExpressions;
}

export interface NextStepModel {
  toStepIds: number[];
  conditions: Conditions;
  preConditions: StepConditions[];
  toStateId: number;
}

export interface TriggerActionModel {
  stepId: number;
  actionId: number;
  conditions: Conditions;
}

export interface DelayReasonModel {
  options: string[];
  interval: number;
  displayCondition: number;
}

export interface RequiredStepModel {
  stepConditions: StepConditions[];
  toStateId: number;
}

export interface StepConditions {
  conditions: StepCondition[];
}

export interface ConditionExpressions {
  activitiesConditions: string;
  nominationConditions: string;
  errorMessage: string;
}

export interface StepCondition {
  stepId: number;
  conditions: Conditions;
  isLogicalNot: boolean;
}

export interface ModifyDataModel {
  activities: ModifyActivityModel[];
  nomination: ModifyNominationModel[];
}

export interface ModifyActivityModel {
  stepId: number;
  data: FieldData[];
  conditions: Conditions;
}

export interface ModifyNominationModel {
  data: FieldData[];
  conditions: Conditions;
}

export interface FieldData {
  field: string;
  value: string;
}

export enum Conditions {
  None = 0,
  NominationLoad = 1 << 0,
  NominationDischarge = 1 << 1,
  NominationHasVaporLine = 1 << 2,
  ActivityStatusCreated = 1 << 3,
  ActivityStatusStarted = 1 << 4,
  ActivityStatusDone = 1 << 5,
  ActivityStatusSkipped = 1 << 6,
  ActivityStatusVoid = 1 << 7,
  TransferTypeTank = 1 << 8,
  TransferTypeDirect = 1 << 9,
  TransferTypeOTS = 1 << 10,
  TransferTypeSL = 1 << 11,
  LineHandling = 1 << 12,
  ActivityNotExist = 1 << 13,
  ActivityStatusPaused = 1 << 14,
  ActivityInPreArrival = 1 << 15,
  ActivityInArrival = 1 << 16,
  ActivityInPrepareTransfer = 1 << 17,
  NoSurveyorNeeded = 1 << 18,
  HasSurveyor = 1 << 19,
  NominationNoVaporLine = 1 << 20
}
